export function pageFunc() {
  if($('#wp-submit').length) {
    var submitText = $('#wp-submit').val();
    submitText = submitText.replace(' »', '');
    $('#wp-submit').val(submitText);  
  };

  //eラーニング申し込みフォーム
  //金額を計算
  function coursePriceFunc() {
    var coursePrice = 0;
    var i = 0;

    var vals = $('#el-table01 input[name="course[]"]:checked').map(function() {
      return $(this).val();
    });

    $('#tab01 div[data-class="wpcf7cf_group"]').each(function() {
      var groupId = $(this).data('id');
      groupId = groupId.replace('_res', '');
      $(this).removeClass('active');

      if($.inArray(groupId, vals) !== -1) {
        if(i % 2 == 0) {
          $(this).addClass('active');
        }
        var inputNum = $(this).find('input');
        var str = $(inputNum).attr('name');
        var cut_str = '_';
        var index = str.indexOf(cut_str);
        str = str.slice(index + 1);
        coursePrice += Number($(inputNum).val()) * Number(str);

        i++;
      }
    });

    var courseTax = coursePrice * 0.1;
    var courseTotal = coursePrice * 1.1;

    $('#course-price').val('¥' + coursePrice.toLocaleString());
    $('#course-tax').val('¥' + courseTax.toLocaleString());
    $('#course-total').val('¥' + courseTotal.toLocaleString());
  }

  $(document).on('change', '#el-table01 input[name="course[]"]', function() {
    var vals = $('#el-table01 input[name="course[]"]:checked').map(function() {
      return $(this).val();
    });
    var courseNum = vals.length;
    $('#course-num').val(courseNum + 'コース');

    coursePriceFunc();
  });

  //ID数入力で金額計算
  $(document).on('focusout', '#tab01 .course-num-input', function() {
    coursePriceFunc();
  });

  //eラーニング定額コースパッケージ
  var ids = [];
  var ids = $('#el-form-tab01 .el-form__list input').map(function() {
    return $(this).parents('.wpcf7-form-control').attr('id');
  });

  var courses = [];
  $.each(ids, function(index, value) {
    courses = $('#el-table02 .' + value).map(function() {
      var courseNo = $(this).find('td:nth-child(2)').text();
      var courseName = $(this).find('td:nth-child(3)').text();
      $('#el-table02-02').find('.' + value + ' tbody').append('<tr><td>' + courseNo + '</td><td>' + courseName + '</td></tr>');
    });
  });

  $('.wpcf7-form-control-wrap.package input').on('change', function() {
    var ids = [];
    var ids = $('.el-form__list input[name="package[]"]:checked').map(function() {
      return $(this).parents('.wpcf7-form-control').attr('id');
    });

    $('#el-table02 .el-ck__input-span').removeClass('active');
    $.each(ids, function(index, value) {
      $('#el-table02').find('.' + value + ' .el-ck__input-span').addClass('active');
    });
  });

  //eラーニング定額コースカスタマイズ
  var submit = $('#el-form-tab02 input[type="submit"]');
  submit.hide();

  //選択上限数を取得
  function funcSelectNum() {
    selectNum = '';
    var selectNum = $('.wpcf7-form-control-wrap.customize').find('input:checked').parents('.el-radio__input').attr('id');
    selectNum = selectNum.replace('customize', '');
    selectNum = selectNum.replace('-js', '');
    selectNum = Number(selectNum);
    return selectNum;
  }

  //すでに選択しているコース数を取得
  function funcCourseNum() {
    var courses = $('input[name="customize-course[]"]:checked').map(function() {
      return $(this).val();
    });
    return courses.length;
  }

  //パッケージを選択したとき
  $('.wpcf7-form-control-wrap.customize input').on('change', function() {
    var course = $(this).val();
    $('#el-c-course-js').text(course);

    //コースを変更したときに上限を変更
    var courseNum = funcCourseNum();
    var selectNum = funcSelectNum();

    $('.select-num-js').text(selectNum);

    var $not = $('input[name="customize-course[]"]').not(':checked');

    if(courseNum > selectNum) {
      $not.attr('disabled', true);
      $not.parents('tr').addClass('disabled');
    } else if(courseNum === selectNum){
      $not.attr('disabled', true);
      $not.parents('tr').addClass('disabled');
      submit.show();
      $('#v-ck-btn').hide();
    } else {
      $not.attr('disabled', false);
      $not.parents('tr').removeClass('disabled');
      submit.hide();
      $('#v-ck-btn').show();
    }
  });

  //コースを選択したとき
  $('input[name="customize-course[]"]').on('change', function() {
    var courses = [];
    $('#el-res-table--course-js tbody').html('');
    var courses = $('input[name="customize-course[]"]:checked').map(function() {
      var id = $(this).parents('tr').find('.course-id-js').text();
      var courseName = $(this).parents('tr').find('.course-name-js').text();
      return {[id]: courseName};
    });
    $.each(courses, function() {
      $.each(this, function(key, item) {
        $('#el-res-table--course-js tbody').append('<tr><td>'+ key +'</td><td>' + item + '</td></tr>');
      });
    });

    var courseNum = courses.length;
    $('.el-form__dl--total dd span').text(courseNum);

    var selectNum = funcSelectNum();
    var $not = $('input[name="customize-course[]"]').not(':checked');

    if(courseNum > selectNum) { //上限に達したとき
      $not.attr('disabled', true);
      $not.parents('tr').addClass('disabled');
      $('#el-form-tab02 input[type="submit"]').removeClass('.disabled');
    } else if(courseNum === selectNum){
      $not.attr('disabled', true);
      $not.parents('tr').addClass('disabled');
      submit.show();
      $('#v-ck-btn').hide();
    } else { //上限に足りないとき
      $not.attr('disabled', false);
      $not.parents('tr').removeClass('disabled');
      submit.hide();
      $('#v-ck-btn').show();
    }
  });

  //選択したコースが足りないときにアラートを表示
  $('#v-ck-btn').on('click', function(){
    var courseNum = funcCourseNum();
    var selectNum = funcSelectNum();
    if(courseNum > selectNum) {
      var residue = courseNum - selectNum;
      alert(residue + '個コース減らしてください。');
    } else {
      var residue = selectNum - courseNum;
      alert('残り' + residue + '個コース選択してください。');
    }
  });

  //コラムの見出しの折りたたみ
  $('.toc_title').on('click', function() {
    $(this).next('.toc_list').slideToggle();
    $(this).toggleClass('active');
  });
}
